import React from 'react';
import { convictionStep, pillarStep } from '../utils/convictionLabel';

/**
 * VerdictChip — a small Favorable / Neutral / Cautious pill derived from a score,
 * so the authed Screener + Portfolio speak the same verdict-first language as the
 * redesigned grade view. Inline-styled so it drops in anywhere without CSS wiring.
 */
const hexBg = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, 0.13)`;
};

// `conviction`: the five conviction labels (Favorable 78+ ... Unfavorable <48,
// utils/convictionLabel.js). Without it the score is a pillar: Strong / Mixed /
// Weak at 60/40. Was favAt={72} neuAt={48} with Favorable/Neutral/Cautious,
// a second scale that disagreed with the docs.
export default function VerdictChip({ score, max = 100, big = false, conviction = false }) {
  if (score == null || !isFinite(score)) return null;
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const st = conviction ? convictionStep(pct) : pillarStep(pct);
  const c = { fg: st.color, bg: hexBg(st.color), word: st.label || st.word };
  const dot = big ? 7 : 5;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: big ? 7 : 5,
      fontSize: big ? 12 : 10.5, fontWeight: 700, letterSpacing: '0.02em',
      lineHeight: 1.6, padding: big ? '4px 11px' : '2px 8px', borderRadius: 999,
      color: c.fg, background: c.bg, whiteSpace: 'nowrap',
    }}>
      <span style={{ width: dot, height: dot, borderRadius: '50%', background: 'currentColor', flexShrink: 0 }} />
      {c.word}
    </span>
  );
}
